module.exports = __webpack_public_path__ + "img/bruxelles-oro-2019.c8f6a8d9.png";